import React from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import moment from 'moment';
import { NavLink } from "react-router-dom";
import {getUserjobs, getUserjob, registerUserjob, updateUserjob, deleteUserjob } from './../../actions/userjob';
import { getUsertypes } from './../../actions/usertype';
import FormUserJob from "views/Form/FormUserJob";
import $ from 'jquery';

class BottomCard extends React.Component {
   constructor(props){
       super(props);
       this.state ={
           id:null,
           cat:null,
            grp:null,
            afid:false,
            tfid:false,
            cfid:false,
            mfid:false,
            ifid:false,
            mid:null,
            fid:false,
            data:{},
            subtopic:'All Categories',
            started:'',
            ended:'',
            daterange:'',
            isshown:{}

       }
   }
    componentDidMount(){
        //GET PROPS
        let id = parseInt(this.props.id);
        let jobid = this.props.jobid ? parseInt(this.props.jobid) : null;
        let choicestarted = this.props.choicestarted ? this.props.choicestarted : null;
        let choiceended = this.props.choiceended ? this.props.choiceended : null;
        let started = this.props.defaultstarted ? this.props.defaultstarted : null;
        let ended = this.props.defaultended ? this.props.defaultended : null;
        
        if(choicestarted !== null && choiceended !== null && choiceended > choicestarted)
        {
            started = choicestarted;
            ended = choiceended;
        }

        let daterange = ' '+moment(started).format('MMMM Do YYYY') + ' - ' + moment(ended).format('MMMM Do YYYY');
        
        this.setState({
            id:id, 
            cat:jobid,
            started:started,
            ended:ended,
            daterange:daterange
        });
        
        if(id === 1)
        {
            //GET ALL JOBS
            let params = {
                data:{},
                cat:'all',
                table:'user_jobs'
            }
         
         this.setState({subtopic:'User Categories List'});
         this.props.getUserjobs(params);
         $('#myTablex').DataTable();
        }
    }   
    componentDidUpdate(prevProps, prevState)
    {
        //GET PROPS
        if(prevProps.id !== this.props.id || prevProps.choicestarted !== this.props.choicestarted || prevProps.choiceended !== this.props.choiceended)
        {
        let id = parseInt(this.props.id);
        let jobid = this.props.jobid ? parseInt(this.props.jobid) : null;
        let jobname = this.props.job ? parseInt(this.props.jobname) : '';
        let userid = this.props.userid ? parseInt(this.props.userid) : null;
        let username = this.props.user ? parseInt(this.props.username) : '';
        let choicestarted = this.props.choicestarted ? this.props.choicestarted : null;
        let choiceended = this.props.choiceended ? this.props.choiceended : null;
        let started = this.props.defaultstarted ? this.props.defaultstarted : null;
        let ended = this.props.defaultended ? this.props.defaultended : null;
        this.setState({id:id, cat:jobid});
        this.setState({grp:id});
        
        if(choicestarted !== null && choiceended !== null && choiceended > choicestarted)
        {
            started = choicestarted;
            ended = choiceended;
        }

        let daterange = ' '+moment(started).format('MMMM Do YYYY') + ' - ' + moment(ended).format('MMMM Do YYYY');
        
        this.setState({
            id:id, 
            cat:jobid,
            started:started,
            ended:ended,
            daterange:daterange
        });
       
        if(id === 1)
        {
            //GET ALL JOBS
            let params = {
                data:{},
                cat:'jobuserall',
                table:'user_jobs'
            }
         
         this.setState({subtopic:'User Categories List'});
         this.props.getUserjobs(params);
        }
        
    }
    }
    //EDIT JOB
    jobEditForm = (id, dat) =>{
        this.props.getUserjob(id);
        this.setState({cfid:true, mid:id});
    }
    //REPORT
    jobReport = (cid, catname) =>{
        this.setState({id:5});
        //GET ALL USERS
         //GET USER TRANSACTIONS PARTICULAR TYPE
            //DATE RANGE NEEDED
            //INVTORY ID NEEDED
            let dt = {
                'starts':this.state.started,
                'ends':this.state.ended,
                'userid':cid,
            }
            let params = {
                data:JSON.stringify(dt),
                cat:'usertransaction',
                table:'user_transactions'
            }
        let catn = 'User History :' + catname + this.state.daterange;
        this.setState({subtopic:catn});
        this.props.getUsertransactions(params);
    }
    //EXPAND
    jobExpand = (cid, catname) =>{
        this.setState({id:3});
        //GET ALL USERS
        let params = {
            data:{'jobid':cid},
            cat:'jobuser',
            table:'user_types'
        }
        this.setState({subtopic: catname});
        this.props.getUsertypes(params);
    }
    //EXPAND
    jobAdd = (id, dat) =>{
        this.props.userAdd(id)
        
    }
    addCat = (id, dat) =>{
        this.setState({cfid:true, mid:null})
        
    }
    //DELETE JOB
    jobDeleteForm = (id, dat) =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('is_delete', 1);
                fd.append('cat', 'update');
                fd.append('table', 'user_jobs');
                this.props.updateUserjob(fd);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })      
    }
    //ACTIVATE JOB
    jobActivateForm = (id, ac) =>{
        let act = ac === 1 ? 0 : 1;
        let fd = new FormData();
        fd.append('id', id);
        fd.append('is_active', act);
        fd.append('cat', 'update');
        fd.append('table', 'user_jobs');
        this.props.updateUserjob(fd);
    }
    //ADD A TRANSACTION
    addTransactionForm = id =>{
        this.props.userTransactionAdd(id)
    }
    //EDIT USER
    editForm = id =>{
        this.props.getUsertype(id);
        this.setState({fid:true, mid:id});
    }
    //EDIT USER
    accessForm = (id, data) =>{
        this.props.getUsertype(id);
        this.setState({afid:true, mid:id, data:data});
    }
    //DELETE USER
    deleteForm = id =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('is_delete', 1);
                fd.append('cat', 'update');
                fd.append('table', 'user_types');
                this.props.updateUsertype(fd);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })
        
    }
    //ACTIVATE USER
    activateForm = (id, ac) =>{
        let act = ac === 0 ? 1 : 0;
        let fd = new FormData();
        fd.append('id', id);
        fd.append('is_active', act);
        fd.append('cat', 'update');
        fd.append('table', 'user_types');
        this.props.updateUsertype(fd);
    }
    //EDIT USER TRANSACTION
    transactionEditForm = id =>{
        this.props.getUsertransaction(id);
        this.setState({tfid:true, mid:id});
    }
    //DELETE USER TRANSACTION
    transactionDeleteForm = id =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                this.props.deleteUsertransaction(id);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })
        
    } 
    loadShown = (id, cat) =>{
          let ar = {};
          if(cat === 0)
          {
              ar[id] = true;
          }else{
              ar[id] = false;
          }
          this.setState({isshown:ar});
    }

    render() {
        let { cfid, mid, isshown } = this.state  || '';
        let data = this.props.userjobs.userjobs;
        let tabl = data && Array.isArray(data) && data.length > 0 ? data.map((prop, ind)=>{
            if(prop !== null){
            
            return <tr 
            key={ind}
                        style={{padding:'1px', margin:'0px'}}
                        onMouseEnter={()=>this.loadShown(prop.id, 0)}
                        onMouseLeave={()=>this.loadShown(prop.id, 1)}
                        >
                        <td className='text-center' width='10px' data-col-width='4' style={{maxWidth:'10px'}}>{ind + 1}</td>
                        <td className='text-left'>
                             {parseInt(prop.is_active) === 0 ? prop.name : <strike>{prop.name}</strike> }
                             { prop.id in isshown && isshown[prop.id] === true ? 
                                <span className='reportcontrol pull-right'>
                                    <NavLink to={`/account/users/${prop.id}`}><i className='fa fa-list'></i></NavLink>
                                    <a onClick={()=>this.jobActivateForm(parseInt(prop.id), parseInt(prop.is_active))} href='#'>{<i className= {parseInt(prop.is_active) === 0 ? "fa fa-thumbs-up" : "fa fa-thumbs-down"}></i>}</a>
                                    <a onClick={()=>this.jobEditForm(prop.id, prop)} href='#'><i className='fa fa-edit'></i></a>
                                    <a onClick={()=>this.jobDeleteForm(prop.id, prop)} href='#'><i className='now-ui-icons ui-1_simple-remove'></i></a>
                                </span>
                            : ''}
                            

                        </td>
                        <td className='text-center' style={{maxWidth:'10px'}} >{prop.qty}</td>
                    </tr>}
                }): '';
        


        return (
            <>
            
            {cfid === true? 
            <FormUserJob
                st={cfid}
                mid={mid}
                handleClose={()=>this.setState({mid:null, cfid:false})}
            />:''}
            
              <div className="content">
                  <div className='card'>
                  <div className='card-header tablecardheader'>
                  <h4 className='cardtitl'>Job Roles</h4>
                  <button className='btn btn-sm btn-info' onClick={()=>this.addCat()}><i className='fa fa-plus'></i> Add Role</button>
                  
                  </div>
                  <div className='card-body table-responsive'>
                    <table className=' table-bordered display nowrap table-striped mytables table-condensed table-hover' id='myTablex' width='100%'>
                        <thead>
                            <tr>
                                <th style={{maxWidth:'10px'}}>SN.</th>
                                <th>Job Roles</th>
                                <th style={{maxWidth:'10px'}} className='text-center'>QTY.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tabl}
                        </tbody>
                    </table>
                  </div>
                  </div>
              </div>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({ 
    user:state.userReducer.user,
    userjobs:state.userjobReducer
  })
  
export default connect(mapStateToProps, 
    { 
        getUserjobs, 
        getUserjob, 
        registerUserjob,
        updateUserjob,
        deleteUserjob,
        getUsertypes
    })(BottomCard)
